module.exports = __webpack_public_path__ + "static/media/dragon_2.3f3714a1.jpg";